import { EnvironmentData } from "@environments/environment-data.type";

export const environment: EnvironmentData = {
	production: false,
};
